import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Theme,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useApi } from "../../../api/use-api";
import { requestsList } from "../../../api/log/log";
import { Button } from "../../../components/button/button";
import { makeStyles } from "@mui/styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import useScreenSize from "../../../utils/use-screen";
import { Link } from "react-router-dom";

const CELLS = [
  "id",
  "UId",
  "AId",
  "createdAt",
  "ip",
  "origin",
  "url",
  "method",
  "platform",
  "version",
  "userAgent",
  "cache",
  "screenWidth",
  "screenHeight",
  "body",
];

export const Logs: FC = () => {
  const { api: requestsListApi, data: logs, loading } = useApi(requestsList);

  const { isDesktop } = useScreenSize();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const classes = useClass();

  const { values, errors, handleSubmit, handleChange, setFieldValue } =
    useFormik({
      validationSchema: Yup.object({
        accountId: Yup.string(),
        userId: Yup.string(),
        date: Yup.string(),
      }),
      initialValues: {
        accountId: "",
        userId: "",
        date: "",
      },
      onSubmit: (data) => {
        requestsListApi({
          skip: page * limit,
          limit: limit,
          ...data,
        });
      },
    });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accountId = urlParams.get("accountId");
    const date = urlParams.get("date");
    requestsListApi({
      skip: 0,
      limit: 15,
      ...(accountId ? { accountId } : {}),
      ...(date ? { date } : {}),
    });
    if (accountId) {
      setFieldValue("accountId", accountId);
    }
    if (date) {
      setFieldValue("date", date);
    }
  }, [requestsListApi, setFieldValue]);

  return (
    <Box
      overflow={"none"}
      display="flex"
      flexDirection="column"
      maxWidth={"100%"}
    >
      <Box component="form" m={1} onSubmit={handleSubmit}>
        <TextField
          size="small"
          id="accountId"
          name="accountId"
          placeholder="accountId"
          value={values.accountId}
          error={!!errors.accountId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="userId"
          name="userId"
          placeholder="userId"
          value={values.userId}
          error={!!errors.userId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="date"
          name="date"
          placeholder="date"
          value={values.date}
          error={!!errors.date}
          onChange={handleChange}
          className={classes.inputs}
        />
        <Button
          variant="outlined"
          type="submit"
          loading={loading}
          disabled={loading}
        >
          submit
        </Button>
      </Box>
      <Paper
        component={Grid}
        width={isDesktop ? "80vw" : "100vw"}
        overflow={"scroll"}
      >
        <TableContainer sx={{ width: "100%", overflowX: "scroll" }}>
          <Table aria-labelledby="tableTitle" size={"small"}>
            <TableHead>
              <TableRow>
                {CELLS.map((item) => (
                  <TableCell key={item}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {logs?.list.map((item) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.userId.slice(-8)}</TableCell>
                    <TableCell>
                      <Link to={"/app/users/?accountId=" + item.accountId}>
                        {item.accountId.slice(-8)}
                      </Link>
                    </TableCell>
                    <TableCell>{item.createdAt}</TableCell>
                    <TableCell>{item.ip}</TableCell>
                    <TableCell>{item.origin}</TableCell>
                    <TableCell>{item.url}</TableCell>
                    <TableCell>{item.method}</TableCell>
                    <TableCell>{item.platform}</TableCell>
                    <TableCell>{item.version}</TableCell>
                    <TableCell>{item.userAgent}</TableCell>
                    <TableCell>{item.cache}</TableCell>
                    <TableCell>{item.screenWidth}</TableCell>
                    <TableCell>{item.screenHeight}</TableCell>
                    <TableCell>{JSON.stringify(item.body)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[15, 30, 60, 100, 200, 500, 1000]}
          count={logs?.count || 0}
          rowsPerPage={limit}
          page={page}
          onPageChange={(_, page) => {
            requestsListApi({
              skip: page * limit,
              limit: limit,
              accountId: values.accountId || "",
              date: values.date || "",
              userId: values.userId || "",
            });
            setPage(page);
          }}
          onRowsPerPageChange={(e) => {
            setLimit(parseInt(e.target.value));
            requestsListApi({
              skip: page * parseInt(e.target.value),
              limit: parseInt(e.target.value),
              accountId: values.accountId || "",
              date: values.date || "",
              userId: values.userId || "",
            });
          }}
        />
      </Paper>
    </Box>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  inputs: {
    margin: `${theme.spacing(0, 0.5)} !important`,
  },
}));
